t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="$t('cameras.question')"
        :counter.sync="cameras"
        :image="require('@/assets/' + camerasImg)"
      >
      </CountImageInput>
      <one-button type="primary" class="next-btn" @click.native="next()">
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountImageInput from "../../components/CountImageInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import {
  getStepIndex,
  redirectToUnselectedStepIfAny,
  getPrevStepUrl,
  getNextStepUrl
} from "@/utils/steps.js";

export default {
  name: "Cameras",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("cameras"),
      getPrevStepUrl: getPrevStepUrl,
      cameras: this.$store.state.data.cameras,
      camerasImg: "camera.png"
    };
  },
  watch: {
    displays: function() {
      this.updateCameras(this.cameras);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateCameras"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
